export default __webpack_public_path__ + "static/media/white_icon_upload.3b4e9b8c.svg";